<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工列表{{ pageType }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="12">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable style="width: 300px" @clear="getqiyeList" @change="getqiyeList">
            <el-button slot="append" icon="el-icon-search" @click="getqiyeList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialog" v-if="caozuo_type !== '1'">添加员工</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="qiyeList" style="width: 100%" border stripe @row-click="rowClickEv">
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->

            <el-table-column v-if="pageType === 1">
              <template scope="scope">
                <el-radio :label="scope.$index + 1" v-model="mendianUidSelect" @change.native="getMendianInfo(scope.row.uid, scope.row.qiye_bianhao, scope.row.qiye_name, scope.row.qiye_mob)"></el-radio>
              </template>
            </el-table-column>
            <el-table-column type="expand" v-if="pageType === 4">
              <template slot-scope="scope">
                <el-table :data="scope.row.mingxi_list" stripe style="background-color: #f0f9f9">
                  <el-table-column prop="mingxi_money" label="明细金额"></el-table-column>
                  <el-table-column prop="add_time" label="时间"></el-table-column>
                </el-table>
              </template>
            </el-table-column>

            <el-table-column prop="uid" label="uid" width="50"></el-table-column>
            <el-table-column prop="chengshi_name" label="城市"></el-table-column>
            <el-table-column prop="qiye_bianhao" label="员工编号"></el-table-column>

            <el-table-column prop="qiye_xuliehao" label="序列号" width="280"></el-table-column>
            <el-table-column prop="qiye_name" label="员工名称"></el-table-column>

            <el-table-column label="企业类型">
              <template v-slot="scope">
                {{ scope.row.qiye_type === 1 ? '抢单员工' : scope.row.qiye_type === 2 ? '特许加盟员工' : '亿业联盟员工' }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="qiye_account_yingjiao" label="应缴总额"></el-table-column> -->
            <!-- <el-table-column prop="qiye_account_xiaofei" label="已开单总额"></el-table-column> -->
            <el-table-column prop="qiye_lxr" label="管理人"></el-table-column>
            <el-table-column prop="qiye_mob" label="手机" width="130"></el-table-column>
            <el-table-column prop="qiye_addr" label="地址"></el-table-column>
            <el-table-column prop="qiye_tel" label="电话" width="130"></el-table-column>
            <el-table-column prop="yong_flag" label="状态" v-if="false">
              <template v-slot="scope">
                <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.yong_flag"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="caozuo_type !== '1'" width="250">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="施工管理" placement="top" :enterable="false" v-if="false">
                  <el-button type="primary" icon="el-icon-ice-cream-round" circle size="mini" @click="openShigong(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="员工库存" placement="top" :enterable="false" v-if="false">
                  <el-button type="primary" icon="el-icon-shopping-bag-2" circle size="mini" @click="openKucun(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="入库管理" placement="top" :enterable="false" v-if="false">
                  <el-button type="primary" icon="el-icon-sold-out" circle size="mini" @click="openRuku(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="出库管理" placement="top" :enterable="false" v-if="false">
                  <el-button type="primary" icon="el-icon-sell" circle size="mini" @click="openChuku(scope.row.uid)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加员工部分 -->
      <el-dialog title="添加员工" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="编号" prop="qiye_bianhao">
            <el-input v-model="addForm.qiye_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="qiye_type">
            <el-select v-model="addForm.qiye_type" placeholder="请选择">
              <el-option v-for="item in options_qiye" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="qiye_name">
            <el-input v-model="addForm.qiye_name"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="product_chengshi">
            <el-select v-model="addForm.chengshi_uid" placeholder="请选择城市">
              <el-option v-for="item in chengshiList" :key="item.uid" :label="item.chengshi_bianhao + '|' + item.chengshi_name" :value="item.uid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管理人" prop="qiye_lxr">
            <el-input v-model="addForm.qiye_lxr"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="qiye_mob">
            <el-input v-model="addForm.qiye_mob" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="addForm.qiye_tel" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="联系地址">
            <el-input v-model="addForm.qiye_addr" max="11" min="10"></el-input>
          </el-form-item>
          <!-- <el-form-item label="员工单图">
            <span>* 提示：只能加一张图片</span>
            <div style="height: 100%">
              <picUpload ref="picUploadRefShoukuanma" @backPicUrl="backPicUrl_shoukuanma" show_type="3" :picsUrl="this.pics_shoukuanma" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="员工单图">
            <div style="height: 100%">
              <picUpload @backPicUrl="backPicUrl_shoukuanma" show_type="1" :picsUrl="this.addForm.pics_shoukuanma" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="店铺图片">
            <div style="height: 100%">
              <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.pics" :key="datekey" max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="图片浏览">
            <div style="height: 100%">
              <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="this.addForm.pics" :key="datekey" max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="员工收款码">
            <span>* 提示：只能加一张图片</span>
            <div style="height: 100%">
              <picUpload ref="picUploadRefOne" @backPicUrl="backPicUrl_one" show_type="3" :picsUrl="this.pics_one" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="员工收款码">
            <div style="height: 100%">
              <picUpload @backPicUrl="backPicUrl_one" show_type="1" :picsUrl="this.addForm.pics_one" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="序列号" prop="qiye_xuliehao">
            <el-input v-model="addForm.qiye_xuliehao" :disabled="true"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addqiye" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改员工信息 -->
      <el-dialog title="修改信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="uid" prop="qiye_uid">
            <el-input v-model="editForm.qiye_uid" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="编号" prop="qiye_bianhao">
            <el-input v-model="editForm.qiye_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="product_chengshi">
            <el-select v-model="editForm.chengshi_uid" placeholder="请选择城市">
              <el-option v-for="item in chengshiList" :key="item.uid" :label="item.chengshi_bianhao + '|' + item.chengshi_name" :value="item.uid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="qiye_type">
            <el-select v-model="editForm.qiye_type" placeholder="请选择">
              <el-option v-for="item in options_qiye" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="员工单图">
            <span>* 提示：只能加一张图片</span>

            <picUpload ref="picUploadRefOne" @backPicUrl="backPicUrl_one" show_type="3" :picsUrl="this.pics_one" :key="datekey" max_count="1"></picUpload>
          </el-form-item> -->
          <!-- <el-form-item label="员工单图">
            <picUpload @backPicUrl="backPicUrl_one" show_type="1" :picsUrl="this.editForm.pics_one" :key="datekey" max_count="1"></picUpload>
          </el-form-item>
          <el-form-item label="序列号" prop="qiye_bianhao">
            <el-input v-model="editForm.qiye_xuliehao" :disabled="true"></el-input>
          </el-form-item> -->
          <el-form-item label="名称" prop="qiye_name">
            <el-input v-model="editForm.qiye_name"></el-input>
          </el-form-item>

          <el-form-item label="管理人" prop="qiye_lxr">
            <el-input v-model="editForm.qiye_lxr"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="qiye_mob">
            <el-input v-model="editForm.qiye_mob" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="qiye_mob">
            <el-input v-model="editForm.qiye_tel" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="qiye_mob">
            <el-input v-model="editForm.qiye_addr" max="11" min="10"></el-input>
          </el-form-item>
          <!-- <el-form-item label="员工图片">
            <div style="height: 100%">
              <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.pics" :key="datekey" max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="图片浏览">
            <div style="height: 100%">
              <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="this.editForm.pics" :key="datekey" max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="员工收款码">
            <span>* 提示：只能加一张图片</span>
            <div style="height: 100%">
              <picUpload ref="picUploadRefOne" @backPicUrl="backPicUrl_shoukuanma" show_type="3" :picsUrl="this.pics_shoukuanma" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="员工收款码">
            <div style="height: 100%">
              <picUpload @backPicUrl="backPicUrl_shoukuanma" show_type="1" :picsUrl="this.editForm.pics_shoukuanma" :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-dialog>
      <el-drawer title="施工信息浏览" :visible.sync="shigongDialogVisible" size="60%">
        <span style="padding: 10 10 10 10px">
          <yunyingList :xiugai_type="0" :show_type="2" ref="yunyingRef" :key="datekey"> </yunyingList>
          <!-- :qiye_uid="this.yunying_qiye_uid"   -->
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-drawer>
      <el-drawer title="库存信息浏览" :visible.sync="kucunDialogVisible" size="60%">
        <span style="padding: 10 10 10 10px">
          <kucunList :xiugai_type="0" :show_type="2" ref="kucunRef" :key="datekey"> </kucunList>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-drawer>
      <el-drawer title="入库信息浏览" :visible.sync="rukuDialogVisible" size="60%">
        <span style="padding: 20px 20px 20px 20px">
          <rukuList :xiugai_type="0" :show_type="2" ref="rukuRef" :key="datekey"> </rukuList>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-drawer>
      <el-drawer title="出库信息浏览" :visible.sync="chukuDialogVisible" size="60%">
        <span style="padding: 10 10 10 10px">
          <chukuList :xiugai_type="0" :show_type="2" ref="chukuRef" :key="datekey"> </chukuList>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-drawer>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest } from './config/validator'
import yunyingList from './yunying.vue'
import kucunList from './kucun.vue'
import chukuList from './chuku.vue'
import rukuList from './ruku.vue'
import picUpload from '../tongyong/pic_com.vue'
export default {
  components: {
    yunyingList: yunyingList,
    kucunList: kucunList,
    chukuList: chukuList,
    rukuList: rukuList
    // picUpload: picUpload
  },
  /* 
   caozuo_type   1 浏览 2 管理修改删除
   pageType 1 可以进行选择  4 显示所有明细 
   mingxi_type 1 2  用来显示客户明细
   mingxiMain_type 1 2  显示员工明细类别
  */
  props: ['caozuo_type', 'pageType', 'mingxi_type', 'mingxiMain_type'],
  data() {
    // var checkMobile = (rule, value, cb) => {
    //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    // if (regMobil.test(value)) {
    //    return cb()
    //  }
    //  cb(new Error('请输入合法的手机号!'))
    //  }
    return {
      yunying_qiye_uid: 0,
      datekey: Date.now(),
      options_qiye: [
        {
          value: 1,
          label: '员工'
        }
      ],
      mendianUidSelect: 0,
      mendianUidInfo: {},
      // 获取用户列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list_more',
        C_table_name: 'qiye_list_more',
        query: '',
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: this.mingxiMain_type,
        CI_canshu02: this.mingxi_type
      },
      qiyeList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      shigongDialogVisible: false,
      kucunDialogVisible: false,
      rukuDialogVisible: false,
      chukuDialogVisible: false,

      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'qiye_add',
        qiye_bianhao: '',
        qiye_name: '',
        qiye_lxr: '',
        qiye_mob: '',
        qiye_xuliehao: '',
        qiye_type: ' ',
        qiye_tel: ' ',
        qiye_addr: ' ',
        pics_one: '',
        pics_shoukuanma: '',
        pics: '',
        chengshi_uid: 0
      },
      pics_one: '',
      pics: '',
      pics_shoukuanma: '',
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        qiye_type: [{ required: true, message: '选择类型', trigger: 'change', type: 'number' }],
        qiye_name: [
          { required: true, message: '请输入员工名称', trigger: 'blur' },
          { min: 1, max: 30, message: '必须1到30位字符 ', trigger: 'blur' }
        ],
        qiye_lxr: [
          { required: true, message: '请输入员工管理员', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
        ],
        qiye_mob: [{ validator: checkMobileTest.bind(this.addForm && this.addForm.qiye_mob) }]
      }
    }
  },
  created() {
    this.getqiyeList()
    this.getChengshiList()
  },
  methods: {
    async getChengshiList() {
      // console.log(123)
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_type: 'chengshi_list_select'
        }
      })

      this.chengshiList = JSON.parse(res.data)[0].dataList
    },
    backPicUrl(pics) {
      if (this.addDialogVisible === true) {
        this.addForm.pics = pics
        this.pics = pics
      }

      if (this.editDialogVisible === true) {
        this.editForm.pics = pics
        this.pics = pics
      }
    },
    // 通过不同的事件，返回不同地方的图片上传数据
    backPicUrl_shoukuanma(pics) {
      if (this.addDialogVisible === true) {
        this.addForm.pics_shoukuanma = pics
        this.pics_shoukuanma = pics
      }

      if (this.editDialogVisible === true) {
        this.editForm.pics_shoukuanma = pics
        this.pics_shoukuanma = pics
      }
    },
    // 通过不同的事件，返回不同地方的图片上传数据
    backPicUrl_one(pics) {
      if (this.addDialogVisible === true) {
        this.addForm.pics_one = pics
        this.pics_one = pics
      }

      if (this.editDialogVisible === true) {
        this.editForm.pics_one = pics
        this.pics_one = pics
      }
    },
    handlePictureCardPreview(file) {
      this.previewPath = file.response.url
      this.previewDialogVisible = true
    },
    handleRemove(file) {
      console.log(998, file)
      const filePath = file.response.temp_url

      // const i = this.addForm.pics.findIndex(x => console.log(999, x))
      const i = this.addForm.pics.findIndex((x) => x.temp_url === filePath)
      this.addForm.pics.splice(i, 1)
      console.log(123, this.addForm.pics)
    },
    handleSuccess(response) {
      const picInfo = { url: response.url, temp_url: response.temp_url }
      this.addForm.pics.push(picInfo)
      console.log(123, this.addForm.pics)
    },
    edithandleSuccess(response) {
      const picInfo = { url: response.url, temp_url: response.temp_url }
      // console.log(123, this.editForm)
      this.editForm.pics.push(picInfo)
    },
    rowClickEv(data) {
      console.log(data)
      this.getMendianInfo(data.uid, data.qiye_bianhao, data.qiye_name, data.qiye_mob)
      this.mendianUidSelect = data.row
    },
    getMendianInfo(uid, bianhao, name, mob) {
      console.log(uid)
      // console.log(this.mendianUidSelect)
      //  this.mendianUidSelect = uid
      this.mendianUidInfo = {
        uid: uid,
        qiye_bianhao: bianhao,
        qiye_name: name,
        qiye_mob: mob
      }
      this.$emit('getMendianInfo', this.mendianUidInfo)
    },
    openShigong(uid) {
      //  this.yunying_qiye_uid = uid
      // 不能直接调用，还不存在ƒ√
      this.shigongDialogVisible = true
      this.$nextTick(() => {
        this.$refs.yunyingRef.queryInfo.CI_canshu01 = 2 // 指定企业uid显示
        this.$refs.yunyingRef.queryInfo.CI_canshu02 = uid
        this.$refs.yunyingRef.getyunyingList() // 直接调用组件 ，查询页面
      })
    },
    openKucun(uid) {
      this.kucunDialogVisible = true
      this.$nextTick(() => {
        this.$refs.kucunRef.queryInfo.CI_canshu01 = 2 // 指定企业uid显示
        this.$refs.kucunRef.queryInfo.CI_canshu02 = uid
        this.$refs.kucunRef.getKucunList() // 直接调用组件 ，查询页面
      })
    },
    openChuku(uid) {
      this.chukuDialogVisible = true
      this.$nextTick(() => {
        this.$refs.chukuRef.queryInfo.CI_canshu01 = 2 // 指定企业uid显示
        this.$refs.chukuRef.queryInfo.CI_canshu02 = uid
        this.$refs.chukuRef.getChukuList() // 直接调用组件 ，查询页面
      })
    },
    openRuku(uid) {
      this.rukuDialogVisible = true
      this.$nextTick(() => {
        this.$refs.rukuRef.queryInfo.CI_canshu01 = 2 // 指定企业uid显示
        this.$refs.rukuRef.queryInfo.CI_canshu02 = uid
        this.$refs.rukuRef.getRukuList() // 直接调用组件 ，查询页面
      })
    },
    async getqiyeList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      // console.log(JSON.parse(res.data))
      this.qiyeList = JSON.parse(res.data)[0].dataList
      console.log(this.qiyeList)
      if (!this.qiyeList) return
      this.total = JSON.parse(res.data)[0].total

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getqiyeList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getqiyeList()
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    async addDialog() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 6 }
      })
      console.log(JSON.parse(res.data)[0].bianhao_s)
      this.addForm.qiye_bianhao = JSON.parse(res.data)[0].bianhao_s
      this.addForm.qiye_xuliehao = JSON.parse(res.data)[0].qiye_xuliehao
      // this.total = JSON.parse(res.data)[0].total
      console.log(JSON.parse(res.data)[0])
      this.addDialogVisible = true
    },
    addqiye() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return 1
        if (this.addForm.chengshi_uid === 0) {
          this.$message.error('请选择城市！')
          return 0
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm)
        // console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 201) {
          this.$message.error('企业联系手机号码重复！')
          return
        }

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败')
          return
        }
        this.$message.success('添加成功')
        this.getqiyeList()
        this.addDialogVisible = false
      })
    },
    showEditDialog(uid) {
      this.editDialogVisible = true
      this.qiyeInfo(uid)
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields()
    },
    async qiyeInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'qiye_info', uid: uid, C_type: 'get_info' }
      })
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败')
      }

      this.editForm = JSON.parse(res.data)[0].data[0]
    },
    async updateqiye() {
      this.$refs.editFormRef.validate(async (valid) => {
        console.log(valid)
        if (!valid) return this.$message.error('验证错误！')

        const { data: res } = await this.$http.post('api', {
          C_type: 'qiye_update',
          qiye_uid: this.editForm.qiye_uid,
          qiye_name: this.editForm.qiye_name,
          qiye_lxr: this.editForm.qiye_lxr,
          qiye_mob: this.editForm.qiye_mob,
          qiye_pass: this.editForm.qiye_pass,
          qiye_xuliehao: this.editForm.qiye_xuliehao,
          qiye_type: this.editForm.qiye_type,
          qiye_tel: this.editForm.qiye_tel,
          qiye_addr: this.editForm.qiye_addr,
          pics_one: this.editForm.pics_one,
          pics_shoukuanma: this.editForm.pics_shoukuanma,
          pics: this.editForm.pics,
          chengshi_uid: this.editForm.chengshi_uid
        })
        console.log(123)
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败')
          return
        }
        this.$message.success('更新成功')
        this.getqiyeList()
        this.editDialogVisible = false
      })
    },
    // 删除一条记录
    async deleteForm(qiyeUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'qiye_del',
        C_data1: qiyeUid
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      this.getqiyeList()
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}
</style>
